import {MassiveActionsProcessHeader} from "../components/UtilsComponents";
import * as React from "react";
import {ProcessPage, ProcessStageOrder} from "../../Processes";
import {CodesValidation} from "../components/CodesValidation";
import {MassiveActionProcessState} from "../MassiveActionsProvider";
import {VeboxOverlay} from "../../../components/overlay/VeboxOverlay";
import {ValidatedElement, ValidatedElementList} from "../models";
import {DeleteStage} from "../components/DeleteStage";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {DeleteWarningModal} from "../components/DeleteWarningModal";

declare var AppTranslations: AppTranslations;

async function validateLocations(codes: string[]): Promise<ValidatedElementList> {
    return new Promise((resolve, reject)=> {
        RestDataLoader.postJSON(
            "locations/validation",
            {
                list: codes
            },
            resolve,
            reject,
        );
    });
}


async function deleteLocations(guids: string[]): Promise<void> {
    return new Promise((resolve, reject) => {
        RestDataLoader.deleteJSON(
            "locations",
            {
                list: guids
            },
            resolve,
            reject,
        );
    })
}

export function LocationsDeletionProcess() {

    const overlayController = VeboxOverlay.useTarget(<></>);

    const [list, setList] = React.useState([]);


    async function validateAndGet(codes: string[]): Promise<any> {
        const result = await validateLocations(codes);
        setList(result.validatedElementList);
    }

    async function action(validLocations: ValidatedElement[]): Promise<void> {
        if(validLocations.reduce((count,{equipmentCount}) => count + equipmentCount, 0 ) > 0) {
            return new Promise((resolve, reject) => {
                async function confirm() {
                    return deleteLocations(validLocations.map(({guid}) => guid))
                        .then(() => {
                            setList([]);
                            overlayController.clear();
                            resolve();
                        })
                        .catch((e) => {
                            setList([]);
                            overlayController.clear();
                            reject(e);
                        });
                }

                function close() {
                    overlayController.clear()
                    resolve();
                }

                overlayController.show(<DeleteWarningModal close={close} confirm={confirm}/>);
            });
        } else {
            try {
                await deleteLocations(validLocations.map(({guid}) => guid));
            } catch (e) {
                throw e;
            } finally {
                setList([]);
            }
        }
    }



    return (
        <ProcessPage total={2} className={"flx-col"}>
            <MassiveActionsProcessHeader
                processHeaderTitle={AppTranslations.entityDeleteProcess.locationDeleteTitle}
                processIndicatorsTitles={[
                    AppTranslations.massiveActions.packageClaimProcess.packageCodeStageTitle,
                    AppTranslations.genericWords.delete
                ]}
            />
            <VeboxOverlay.Target {...overlayController.targetProps} className={"process-stages flx-row"}>
                <CodesValidation
                    validationFunction={validateAndGet}
                    stepNumber={1}
                    stageOrder={ProcessStageOrder.FIRST}
                    title={AppTranslations.massiveActions.packageClaimProcess.packageCodeStageTitle}
                    cardTitle={AppTranslations.massiveActions.packageClaimProcess.packageCodeStageTitle}
                    errorMessage={"Error"}
                    errorDescription={"Error message"}
                    massiveActionProcessState={MassiveActionProcessState.INITIAL}
                />
                <DeleteStage title={"Locations"} list={list} action={action}/>
            </VeboxOverlay.Target>
        </ProcessPage>
    );
}